import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Contrast.css";

const ContrastTest = () => {
useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, []);
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(null);

  useEffect(() => {

    const email = localStorage.getItem("user_email");

    if (!email) {
      navigate("/");
      return;
    }

    axios
      .get(`/check-access?email=${email}&test=contrast_sensitivity`)
      .then(res => {

        console.log("API:", res.data);

        if (res.data.allowed) {
          setHasAccess(true);
        } else {
          setHasAccess(false);
        }

      })
      .catch(() => navigate("/"));

  }, []);

  // 🔥 ACCESS CONTROL

  if (hasAccess === null) {
    return <div>Loading...</div>;
  }

  if (hasAccess === false) {
    return (
      <div className="access-denied-container">
        <h2>🚫 Access Denied</h2>
        <p>You don’t have access to this test</p>
        <button onClick={() => navigate("/")}>Go Back</button>
      </div>
    );
  }

  return (
    <div className="contrast-wrapper">

      {/* ================= HEADER ================= */}

      <div className="contrast-header-card">

        <h2 className="contrast-title">Contrast Sensitivity Test</h2>

        <p className="contrast-subtitle">
          Contrast sensitivity measures your ability to detect objects
          against varying backgrounds, especially in low contrast situations.
          It trains the brain to
          <strong> “See → Differentiate → React.”</strong>
        </p>

        <div className="contrast-pill">
          Test type: <strong>Visual perception → Contrast detection</strong>
        </div>

        <hr className="contrast-divider" />

        {/* ================= WHY ================= */}

        <div className="contrast-why-card">

          <h3 className="why-title">
            Why contrast sensitivity matters
          </h3>

          <p className="why-description">
            In real-world and sports scenarios, lighting conditions are not always ideal.
            Strong contrast sensitivity helps you detect objects quickly,
            even in dim light, fog, or glare conditions.
          </p>

          <div className="why-tags">
            <span>Better low-light vision</span>
            <span>Improved object detection</span>
            <span>Sharper visual clarity</span>
            <span>Reduced reaction delay</span>
            <span>Better decision making</span>
          </div>

        </div>

      </div>

      {/* ================= HOW IT WORKS ================= */}

      <div className="how-card">

        <h2 className="how-title">How the game works</h2>

        <ul className="how-list">

          <li>
            You will see shapes or patterns with <strong>varying contrast levels</strong>.
          </li>

          <li>
            Your task is to <strong>identify the visible object or direction</strong>.
          </li>

          <li>
            Contrast will gradually decrease, making it harder to detect.
          </li>

          <li>
            You must respond <strong>quickly and accurately</strong>.
          </li>

          <li>
            Your score depends on how well you detect <strong>low contrast visuals</strong>.
          </li>

        </ul>

        <p className="how-note">
          Best practice: take the test in a normal lighting environment without screen glare.
        </p>

      </div>

      {/* ================= START ================= */}

      <div className="start-test-section">

        <h2>Ready to test your visual clarity?</h2>

        <button
          className="start-test-btn"
          onClick={() => navigate("/contrast/play")}
        >
          Start Test
        </button>

      </div>

    </div>
  );
};

export default ContrastTest;